<template>
  <div id="app">
      <el-header  style="padding: 0px !important;" >
        <el-row>
          <el-col :span="12" style=" background-color:#000000;color: #ebe0b2;font-weight: bold;text-align: left;font-size: 20px;font-family: 微软雅黑;padding-left: 200px;">云南辰璟科技有限公司</el-col>
          <el-col :span="12" style="padding-right: 200px;">
          <el-menu
            :default-active="activeIndex2"
            class="nav el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-menu-item index="1" style=" background-color: transparent;">首页</el-menu-item>
            <el-menu-item index="2" style=" background-color: transparent;">产品中心</el-menu-item>
            <el-menu-item index="3" style=" background-color: transparent;">关于我们</el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
<el-row>
  <el-col :span="12" style=" background-color:#000000;color: #ebe0b2;font-weight: bold;text-align: left;font-size: 20px;font-family: 微软雅黑;padding-left: 200px;height: 500px;text-align: center;padding-top: 150px">
    <h1>公司简介</h1>
    <h2>Company profile</h2>
  </el-col>
  <el-col :span="12" style="   background-color:#303133;height: 500px;color: #ffffff;padding:20px;line-height:40px !important;padding-top: 100px;">
  <span >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;云南辰璟科技有限公司，成立于2021-05-14，注册资本为200万人民币，法定代表人为周培祥，经营状态为存续，工商注册号为530112000747993，注册地址为云南省昆明市西山区春雨路城市景苑2栋403室，经营范围包括计算机技术咨询、技术服务、技术转让；通信终端设备、电子产品、软件、计算机及配件、空调制冷设备的生产、销售；信息系统集成服务；网络科技产品领域内的技术开发、技术转让、技术咨询、技术服务；物联网技术领域内产品的研究、开发、销售；通信设备租赁（不含限制项目）；货物或技术进出口（国家禁止或涉及行政审批的货物和技术进出口除外）；Ⅰ类、Ⅱ类医疗器械的销售及租赁；
    普通机械设备、五金产品的销售；互联网零售；第二类增值电信业务；教育信息咨询（不含教育培训）。（依法须经批准的项目，经相关部门批准后方可开展经营活动</span>
  </el-col>
</el-row>
        <el-row style="line-height: 40px">
          <el-col :span="12" style="   background-color:#C8B370;height: 500px;color: #ffffff;padding:20px;line-height:40px !important;padding-top: 100px;">
            <el-col :span="8">
            <el-image
              style="width:100%;"
              :src="require('@/assets/images/p1.png')"
              :fit="fit"></el-image>
            </el-col>
          <el-col :span="16" style="color: #EBDFAF;">
           <h2>电能采集装置</h2>
            <p>EAT101电能采集装置是一款基于4G CAT1传输的无线电能数据采集终端。支持DI开关量、模拟量AI的输入采集，DO继电器控制输出，支持RS485/RS232接口。整体采用工业化设计，接口隔离保护，是一款高可靠的物联网产品</p>
          </el-col>
          </el-col>
          <el-col :span="12" style="background-color:#ffffff;color: #000000;font-weight: bold;text-align: left;font-size: 20px;font-family: 微软雅黑;padding-left: 200px;height: 500px;text-align: center;padding-top: 150px">
            <h1>产品介绍</h1>
            <h2>Product introduction</h2>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" style=" background-color:#000000;color: #ebe0b2;font-weight: bold;text-align: left;font-size: 20px;font-family: 微软雅黑;padding-left: 200px;height: 500px;text-align: center;padding-top: 150px">
            <h1>联系我们</h1>
            <h2>contact us</h2>
          </el-col>
          <el-col :span="12" style="   background-color:#303133;height: 500px;color: #ffffff;padding:20px;line-height:40px !important;padding-top: 150px;padding-left: 30px">
            <h3 >联系人：朱师 159 7629 1182</h3>
            <h3>地址：云南省昆明市西山区春雨路城市景苑2栋403室</h3>
          </el-col>
        </el-row>
      </el-header>
      <!--<el-main style="padding-top: 0px;padding-bottom: 0px;">-->
      <!--</el-main>-->
      <el-footer>物联网智慧专家     滇ICP备2022003195号-1</el-footer>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style>
  #app{
    height: 100%;
    margin: 0px;
    background-color: #e7ecf2;
  }
  .el-container{
    height: 100%;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  .el-header,.el-footer {
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  .el-header{
    /*padding-left: 200px;*/
    padding: 0px;
    margin: 0px;
    text-align: left;
    background-color:#303133;
    width: 100%;
  }
  body{
    margin: 0px;
    padding: 0px;
  }
  .nav {
    float: right;
    height: 100%;
    line-height: 80px;
    /*background: transparent;*/
    background-color: #303133 !important;
    padding: 0;
    margin: 0;
  }
  .el-footer {
    background-color: #eeefef;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
  }
  body > .el-container {
    /*margin-bottom: 40px;*/
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .el-menu-demo{
    text-align: right;
  }
  .box-card {
    height: 100px;
  }
  .chart {
    height: 200px;
    width: 100%;
  }
  .bgClass {
    background-color: white
  }
  .bgClass1 {
    background-color:#202028
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  .el-menu-item{
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue